import Vue from 'vue';
import { isNew } from './getters';
import getModelsApi from '../../api/get-models-by-make-body-type';
import getMakesApi from '../../api/get-makes';
import {
  GLOBAL_ERROR,
  NEW_YEAR_FUTURE,
  USED_YEAR_PAST
} from '../../utils/constants';

/**
 * Return a year range that used for getModels API
 */
function getModelYearLimits(isNew) {
  const lastYear = new Date().getFullYear() - 1;
  const startYear = isNew ? lastYear : lastYear - USED_YEAR_PAST;
  const endYear = isNew ? lastYear + NEW_YEAR_FUTURE : lastYear;
  return `${startYear},${endYear}`;
}

export async function getModels({ commit, state }) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['loadingModels', true]);
      if (state.selected.makeId && state.selected.bodyType) {
        const models = await getModelsApi({
          make: state.selected.makeId.toString(),
          body: state.selected.bodyType.toString(),
          yearLimits: getModelYearLimits(isNew(state)),
          newOnly: isNew(state)
        });
        commit('setModels', models);
      } else {
        commit('setSelected', ['modelId', null]);
        commit('setModels', []);
      }
      commit('setState', ['loadingModels', false]);
      return resolve();
    } catch (err) {
      commit('setState', ['loadingModels', false]);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR,
        action: () => dispatch('getModels')
      });
      return reject();
    }
  });
}

export async function getMakes({ commit, dispatch }) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['loadingMakes', true]);
      const makes = await getMakesApi();
      commit('setMakes', makes);
      commit('setState', ['loadingMakes', false]);
      return resolve();
    } catch (err) {
      commit('setState', ['loadingMakes', false]);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR,
        action: () => dispatch('getMakes')
      });
      return reject();
    }
  });
}
